import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProfileSlice = createSlice({
    name: "getProfileRequest",
    initialState,
    reducers: {
        getProfileRequest(state) {
            state.loading = true;
        },
        getProfileRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProfileRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProfileRequest,
    getProfileRequestSuccess,
    getProfileRequestError,
} = GetProfileSlice.actions;

export default GetProfileSlice.reducer;
